module.exports = __webpack_public_path__ + "assets/img/u1 (1).2e22bee6.png";